<template>
  <header>
    <div class="header-container w">
      <ul class="nav-link">
        <router-link tag="li" to="/" exact class="logo">
          <svg-icon icon-class="icon_logo" class-name="icon_logo"></svg-icon>
        </router-link>
        <router-link tag="li" to="/" exact>
          <span>首页</span>
        </router-link>
        <router-link tag="li" to="/product-erp">
          <span>产品中心</span>
          <div class="J_hide J_anim J_anim-upbit">
            <dl class="J_H-dl">
              <dd>
                <router-link to="/product-erp">ERP系统</router-link>
              </dd>
              <dd>
                <router-link to="/product-member">线上会员营销系统</router-link>
              </dd>
              <dd>
                <router-link to="/product-health">中医诊疗系统</router-link>
              </dd>
              <dd>
                <router-link to="/product-ncd">慢病管理系统</router-link>
              </dd>
              <dd>
                <router-link to="/product-check">厚科盘点机</router-link>
              </dd>
              <dd>
                <router-link to="/product-educat">在线教育系统</router-link>
              </dd>
            </dl>
          </div>
        </router-link>
        <router-link tag="li" to="/solve">
          <span>解决方案</span>
        </router-link>
        <router-link tag="li" to="/service">
          <span>服务体系</span>
        </router-link>
        <router-link tag="li" to="/case">
          <span>经典案例</span>
        </router-link>
        <router-link tag="li" to="/about">
          <span>关于厚科</span>
        </router-link>
        <li>
          <a href="https://www.houkeyun.com/" target="_blank">厚科云健康</a>
        </li>
      </ul>
      <div class="nav-single">
        <div class="single-item">
          <button>登录</button>
          <div class="J_hide J_anim J_anim-upbit">
            <dl class="J_H-dl">
              <dd>
                <a href="http://bi.szhouke.com/" target="_blank">会员登录</a>
              </dd>
              <dd>
                <a href="http://sms2.szhouke.com/new/login.asp" target="_blank">短信平台</a>
              </dd>
              <!-- <dd>
                <a href="https://www.houkeyun.com/">在线教育</a>
              </dd>-->
            </dl>
          </div>
        </div>
        <span></span>
        <router-link class="try" to="/try">申请使用</router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header"
};
</script>
<style lang="scss" scoped>
@keyframes upbit {
  0% {
    transform: translate3d(0, 30px, 0);
    opacity: 0.3;
  }

  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
header {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9998;
  // background: #6603dc;
  .header-container {
    @include clearfix;
    .nav-link {
      float: left;
      @include clearfix;
      .logo {
        margin-right: 48px;
        .icon_logo {
          width: 142px;
          height: 30px;
          vertical-align: middle;
        }
      }
      .router-link-active {
        span {
          border-bottom: 2px solid #fff;
          padding: 5px 0;
        }
      }
      li {
        float: left;
        height: 58px;
        line-height: 58px;
        position: relative;
        text-align: center;
        cursor: pointer;
        &:not(:first-child) {
          width: 90px;
          font-size: 14px;
          color: #fff;
          a {
            color: #fff;
          }
        }

        &:hover .J_hide {
          display: block;
        }

        .J_hide {
          width: 180px;
          background: #fff;
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
          position: absolute;
          left: -50%;
          top: 58px;
          transform: translate(-50%, 0);
          z-index: 9999;
          display: none;
          border-radius: 2px;
          overflow: hidden;
        }

        .J_anim {
          animation-duration: 0.3s;
          animation-fill-mode: both;
        }

        .J_anim-upbit {
          animation-name: upbit;
        }

        .J_H-dl {
          dd {
            > a {
              display: block;
              font-size: 14px;
              line-height: 44px;
              padding: 0 16px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
              text-align: initial;
            }
            > .router-link-active {
              background: #f2f2f2;
              color: #478af7;
            }
            &:hover {
              background: #f2f2f2;
              > a {
                color: #478af7;
              }
            }
          }
        }
      }
      .nav-try {
        background: #f08300;
        a {
          color: #fff !important;
        }
      }
    }

    .nav-single {
      float: right;
      line-height: 58px;
      .single-item {
        display: inline-block;
        position: relative;
        &:hover .J_hide {
          display: block;
        }
        .J_hide {
          width: 100px;
          border: 1px solid #d2d2d7;
          border-radius: 2px;
          background: #fff;
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
          position: absolute;
          left: 50%;
          top: 54px;
          margin-left: -50px;
          z-index: 9999;
          display: none;
          &::before {
            content: "";
            position: absolute;
            left: 50%;
            top: -6px;
            transform: translate(-50%, 0);
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-bottom: 6px solid #d2d2d7;
            z-index: 10000;
          }
          &::after {
            content: "";
            position: absolute;
            left: 50%;
            top: -5px;
            transform: translate(-50%, 0);
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-bottom: 6px solid #fff;
            z-index: 10000;
          }

          .J_H-dl {
            dd {
              > a {
                display: block;
                font-size: 14px;
                line-height: 44px;
                text-align: center;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.85);
              }
              &:hover {
                background: #f2f2f2;
                > a {
                  color: #478af7;
                }
              }
            }
          }
        }

        .J_anim {
          animation-duration: 0.3s;
          animation-fill-mode: both;
        }

        .J_anim-upbit {
          animation-name: upbit;
        }
      }
      button {
        width: 70px;
        height: 26px;
        line-height: 26px;
        background: #478af7;
        border-radius: 2px;
        color: #fff;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        position: relative;
      }
      span {
        display: inline-block;
        width: 1px;
        height: 12px;
        background: #fff;
        margin: 0 16px;
      }

      .try {
        display: inline-block;
        width: 70px;
        height: 26px;
        line-height: 26px;
        border-radius: 2px;
        border: 1px solid #fff;
        color: #fff;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        position: relative;
      }
    }
  }
}
</style>
